<template>
  <div class="bg">
    <van-form @submit="clickPay">
      <van-field
        v-model="buyerNick"
        name="充值账号"
        label="充值账号"
        :rules="[{ required: true, message: '请输入充值账号' }]"
      />
      <div class="btn">
        <van-button
          color="#F7AF2F"
          native-type="submit"
          :loading="loading"
          loading-text="支付中..."
        >
          华夏点击支付1
        </van-button>
        <van-button
          color="#F7AF2F"
          @click="
            $router.push({
              path: '/test/hxlist',
              query: { openid: $route.query.openid }
            })
          "
          >查看订单1</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { getJsSdk, getPay } from '@/api/testhx.js'
export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      buyerNick: undefined
    }
  },
  async created() {
    const data = await getJsSdk(window.location.origin)
    console.log('jsData', data)
    window.bridgeSvcOuter.init({
      //初始化 初始化JSSDK-校验签名及鉴权
      noncestr: data.noncestr, //随机数 varchar(16)
      timestamp: data.timestamp, //时间戳 varchar(64)
      url: window.location.origin, //初始化URL varchar(128)
      signature: data.sign, //签名 varchar(256)
      appid: data.appid, //合作商id varchar(16)
      debug: true, //开发阶段可打开此标记
      jsapi_ticket: data.jsapi_ticket,
      sign: data.sign,
      success: async function(res) {
        console.log('初始sdk成功', res)
      },
      fail: function(res) {
        console.log('初始sdk失败', res)
      }
    })
  },
  methods: {
    async clickPay() {
      try {
        const activityNumber = this.$route.query.activityNumber
        this.loading = true
        const data = await getPay({
          openid: this.$route.query.openid,
          buyerNick: this.buyerNick,
          activityNumber: activityNumber && activityNumber !== 'undefined'
              ? activityNumber
              : undefined
        })
        console.log('paydata', data)
        // this.loading = false
        window.bridgeSvcOuter.orderPay({
          advancePayId: data.advancePayId, //⽀付订单号
          openid: data.openid, //⽤户id
          mchtNo: data.mchtNo, //⼊驻⽀付平台分配的商户编号
          sign: data.sign, //签名
          // signature: data.sign,
          // returnUrl: window.location.origin, //商户链接，⾮必传
          success: function(res) {
            alert(res?.message)
            console.log('支付成功', res)
          },
          fail: function(res) {
            var message = res.message //错误信息
            console.log('支付error', message)
          }
        })
        this.loading = false
      } catch (error) {
        console.log('error', error)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.bg {
  height: 100vh;
  background: url('~@/assets/hxbg.png') center center no-repeat;
  background-size: 100% 100%;
  .van-field {
    position: fixed;
    bottom: 44%;
    left: 5%;
    width: 90%;
  }
  .btn {
    position: fixed;
    bottom: 10%;
    left: 10%;
    width: 80%;
    display: flex;
    justify-content: space-around;
  }
}
</style>
